export const BACKGROUND_COLOR_DEFAULT = '#324bff';

export const TEXT_COLOR_DEFAULT = '#ffffff';

export const OUTLINE_COLOR_DEFAULT = '#000';
export const SEGMENTS_DEFAULT_COLOR = '#5449D9';
